import { FC, ReactElement } from 'react';

import Button from '~/ui/components/common/Button';
import { IHospitalDetails } from '~/services/api/hospital/types';
import { isoToFormat } from '~/utils/date';
import { DATE_TIME_FORMAT, EMPTY_VALUE } from '../constants';

import styles from './DetailsFooter.module.scss';

interface IProps {
  details: IHospitalDetails;
  onClose: () => void;
  onViewHistory?: () => void;
}

const DetailsFooter: FC<IProps> = ({ details, onClose, onViewHistory }): ReactElement => {
  const lastUpdatedValue = details.lastUpdated || details.lastUpdatedAt;
  const formattedLastUpdated = lastUpdatedValue
    ? isoToFormat(lastUpdatedValue, DATE_TIME_FORMAT, details.patientTimezone)
    : EMPTY_VALUE;

  const onActionClick = () => {
    if (onViewHistory) onViewHistory();
  };

  return (
    <div className={styles.footer}>
      <div className={styles.lastUpdated}>{`Last updated: ${formattedLastUpdated}`}</div>
      <div className={styles.actions}>
        <Button
          variant="outlined"
          color="primary"
          className={styles.closeButton}
          textTransformNone
          onClick={onClose}
        >
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={styles.historyButton}
          textTransformNone
          onClick={onActionClick}
        >
          View History
        </Button>
      </div>
    </div>
  );
};

export default DetailsFooter;
